import React from "react";
import { Container } from "reactstrap";
import LanguageSelector from "./LanguageSelector";
import Logo from "./Logo";
import { motion } from "framer-motion";

const Layout = ({ children }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <LanguageSelector />
      <div className="flex max-w-[1280px] m-auto items-center justify-center px-4 py-12 md:py-32">
        <Container>
          <Logo />
          {children}
        </Container>
      </div>
    </motion.div>
  );
};

export default Layout;
